<tx-loader-wrapper [isLoading]="loading">
  <div class="tx-table">
    <header class="grid">
      <div class="g-col-6" (click)="onSortClicked(columns.FileName)">Document name</div>
      <!-- <div class="g-col-4" (click)="onSortClicked(columns.CreatedDate)">Created date</div>
        <div class="g-col-2" (click)="onSortClicked(columns.CreatedBy)">Created by</div> -->
      <div class="g-col-4" (click)="onSortClicked(columns.ModifiedDate)">Modified date</div>
      <div class="g-col-2" (click)="onSortClicked(columns.ModifiedBy)">Modified by</div>
    </header>
    <div
      *ngFor="let d of documents"
      class="grid tx-table-row"
      [ngClass]="{
        'tx-table-row-active': selectedDocument?.dcmID === d.dcmID
      }"
      (click)="onDocumentSelected(d)"
      (dblclick)="onOpenInNewTabClicked(d)">
      <div class="g-col-6 ps-1 d-flex align-items-center">
        <i class="bi bi-file-earmark"></i>
        <div class="text-truncate" [title]="d.filename">{{ d.filename }}</div>
      </div>
      <!-- <div class="g-col-4">
          {{ d.date | date : "MM/dd/yyyy" }}
          {{ d.time?.toString()?.substring(0, 8) }}
        </div>
        <div class="g-col-2">
          {{ d.createdBy }}
        </div> -->
      <div class="g-col-4">
        {{ getDate(d) }}
        {{ getTime(d) }}
      </div>
      <div class="g-col-2">
        {{ d.modifiedBy != null && d.modifiedBy !== '' ? d.modifiedBy : d.createdBy }}
      </div>
      <div class="action-buttons">
        <div
          *ngIf="allowOpen && !d.openInAnotherSession; else openedBy"
          class="d-flex align-items-center justify-content-end h-100">
          <!-- <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="onOpenClicked(d)">
              Open
            </button> -->
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="onOpenInNewTabClicked(d)">Open</button>
        </div>
        <ng-template #openedBy>
          <span *ngIf="allowOpen">Opened by: {{ d.openedBy }}</span>
        </ng-template>
      </div>
    </div>
  </div>
  <p *ngIf="!isCaseSelected" class="my-3 text-secondary fst-italic">
    Please select a client and case to load the available documents.
  </p>
  <p *ngIf="isCaseSelected && documents.length === 0" class="my-3 text-secondary fst-italic">
    No documents have been found for this case.
  </p>
</tx-loader-wrapper>

<form
  ngNoForm
  [action]="submitUrl"
  method="post"
  enctype="application/x-www-form-urlencoded"
  target="_blank"
  #openInNewTabForm>
  <input type="hidden" id="dcmID" name="dcmID" />
  <input type="hidden" [id]="sessionId" [name]="sessionId" />
</form>
